import { render, staticRenderFns } from "./DashboardTotalsItem.vue?vue&type=template&id=8845ebc6&scoped=true&"
import script from "./DashboardTotalsItem.vue?vue&type=script&lang=js&"
export * from "./DashboardTotalsItem.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTotalsItem.vue?vue&type=style&index=0&id=8845ebc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8845ebc6",
  null
  
)

export default component.exports